<template>
    <div class="app-container">
        <div class="app-header">
            <div class="group_1_header flex-row">
                <img class="image_1_header" referrerpolicy="no-referrer" src="@/assets/img/home/logo.png" />
                <span class="text_1_header">北京市东元（深圳）律师事务所</span>
                <img class="thumbnail_1_header" referrerpolicy="no-referrer" src="@/assets/img/home/1.png" />
                <span class="text_2_header"><a href="tel:8618188641716" target="_blank">181-8864-1716</a></span>
            </div>
            <div class="menu_header">
                <ul>
                    <li v-for="item in menuList" :key="item.id" @click="routerLink(item.path)">
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <router-view />
        <Right></Right>
        <Footer></Footer>
    </div>
</template>

<script>

import Footer from "@/components/Footer";
import Right from "@/components/Right";

import { listMenu } from "@/api/web";
export default {
    name: "home",
    components: {
        Footer, Right
    },
    data() {
        return {
            menuList: [],
            queryParams: {
                mobile: false,
            }
        };
    },
    created() {
        this.getList();
    },
    mounted() {

    },
    methods: {
        getList() {
            listMenu(this.queryParams).then(response => {
                this.menuList = response.rows;
            })
        },
        routerLink(path) {
            this.$router.push({
                path: path
            })
        },
    }

}
</script>
<style lang="scss" src="@/assets/css/web/common.css" />
<style lang="scss" scoped src="@/assets/css/web/home.css" />
<style>
/* 以下代码是为了解决移动端页面缩放问题 */
@media screen and (min-width:750px) and (max-width:1024px) {
    body {
        zoom: 50%;
    }
}

@media screen and (min-width:1050px) and (max-width:1400px) {
    body {
        zoom: 75%;
    }
}

@media screen and (min-width:1400px) and (max-width:1500px) {
    body {
        zoom: 95%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/web/home.vue